import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryTypleListComponent } from './category-typle-list/category-typle-list.component';
import { CategoryTypeAddUpdateComponent } from './category-type-add-update/category-type-add-update.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NeoTableLibModule } from 'neo-table-lib';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { CoreModule } from 'src/app/core/core.module';

const routes: Routes = [
  {
    path: 'categoryType',
    component: CategoryTypleListComponent,
  },
  {
    path: 'categoryTypeList',
    component: CategoryTypleListComponent,
  },
  {
    path: 'categoryTypeAddUpdate',
    component: CategoryTypeAddUpdateComponent,
  },
  {
    path: 'categoryTypeAddUpdate/:id',
    component: CategoryTypeAddUpdateComponent,
  },
];
@NgModule({
  declarations: [CategoryTypleListComponent, CategoryTypeAddUpdateComponent],
  imports: [
    CommonModule,
    CoreModule,
    NgSelectModule,
    Ng2SmartTableModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    NeoTableLibModule,
  ],
  exports: [
    CategoryTypleListComponent
  ],
  entryComponents: [
    CategoryTypleListComponent
  ]
})
export class CategoryTypeModule {}
